import { useEffect } from 'react'
import notFound from '../../assets/images/notfound/404.png'
import styles from './style.module.scss'

export const NotFound = () => {
    useEffect(() => {
        return updateStyle();
    }, []);

    const updateStyle = () => {
        document.body.style.overflowY = 'hidden';
    }

    return <div className={styles['notfound-wrapper']}>
        <img src={notFound} alt="" />
        <p>你要找的页面不见了...</p>
    </div>
}